import cx from 'classnames';
import { CatCard } from '@blocks-react/components/Card';
import { CatBadge } from '@blocks-react/components/Badge';
import { NEW_STATE } from '../../../../constants/commonConstants';
import { ServiceInsightTabletMobileCardProps } from '../../types';
import { ServiceInsightDetails } from '../service-insight-details';
import styles from '../../customer-account.module.scss';

export const ServiceInsightTabletMobileCard = ({
  serviceInsights,
  handleRedirectUrlToAlp
}: ServiceInsightTabletMobileCardProps) => {
  const handleClick = () => {
    if (serviceInsights.id && handleRedirectUrlToAlp)
      handleRedirectUrlToAlp(serviceInsights.id, serviceInsights.equipmentInfo);
  };
  const isNewInsight = serviceInsights.userRelatedState === NEW_STATE;
  return (
    <CatCard removePadding data-testid="cat-card" onClick={handleClick}>
      <div
        className={cx(`${styles['service_card']} d-flex`, {
          'ms-4': !isNewInsight
        })}
      >
        {isNewInsight && (
          <CatBadge
            isDot
            className={`cat-u-margin-right-sm cat-u-margin-left-sm d-flex align-items-start ${styles['service_card--new_indicator']}`}
            data-testid="cat-badge"
          />
        )}
        <ServiceInsightDetails
          serviceInsights={serviceInsights}
          handleRedirectUrlToAlp={() => handleRedirectUrlToAlp}
          isDeskTop={false}
        />
      </div>
    </CatCard>
  );
};
